'use strict';
import * as T from 'prop-types';

export const ButtonState = {
  /** @type {ButtonState} No request in flight. Ready to send one. */
  START: 0,
  /** @type {ButtonState} Actively sending a request and awaiting a response. */
  CONFIRM: 1,
  /** @type {ButtonState} Received a successful response with content. */
  WORKING: 2,
  /** @type {ButtonState} Received a successful, but empty, response. */
  SUCCESS: 3,
  /** @type {ButtonState} Received an error response. */
  ERROR: 4,
};

export const isButtonState = T.oneOf(Object.values(ButtonState));

/**
 * @typedef {Number} ButtonState
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/enums/ButtonState.js